import {Fragment, useMemo} from 'react';
import {usePaginate, DOTS} from './hooks/usePagination';
import cn from 'classnames';
import {SpanIcon} from '@mazraeapp/react_icon_kit';

interface CustomPaginateProps {
  currentPage: number;
  totalCount: number;
  perPageSize: number;
  onPageChange: (pageNumber: number) => void;
}
const CustomPaginate = ({
  currentPage,
  perPageSize,
  totalCount,
  onPageChange,
}: CustomPaginateProps) => {
  if (totalCount <= 1) return null;

  const paginationRange = usePaginate({
    currentPage: currentPage,
    totalCount,
    siblingCount: 1,
    pageSize: perPageSize,
  });

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const lastPage = useMemo(
    () => Math.ceil(totalCount / perPageSize),
    [perPageSize],
  );

  return (
    <div className="flex w-full flex-row-reverse justify-center text-x">
      <button onClick={onPrevious} disabled={currentPage === 1}>
        <SpanIcon
          className={cn('icon-nameArrow---Left-2 mr-4 text-2xl', {
            'text-gray-200': currentPage === 1,
          })}
        />
      </button>
      {paginationRange?.map((pageNumber, index) => {
        return (
          <Fragment key={index}>
            {pageNumber === DOTS ? (
              <div className="pagination-item dots">&#8230;</div>
            ) : (
              <button
                className={cn(
                  'flex w-[32px] h-[32px] items-center rounded-[8px] justify-center text-gray-800',
                  {
                    'bg-farm-shop-500 !text-white': pageNumber === currentPage,
                  },
                )}
                onClick={() => onPageChange(pageNumber as number)}
              >
                {pageNumber}
              </button>
            )}
          </Fragment>
        );
      })}
      <button onClick={onNext} disabled={currentPage === lastPage}>
        <SpanIcon
          className={cn('icon-nameArrow---Right-2 ml-4 text-2xl', {
            'text-gray-200': currentPage === lastPage,
          })}
        />
      </button>
    </div>
  );
};

export default CustomPaginate;
